import React, { useState } from 'react';
import Icon from 'components/AppIcon';

export default function ImportHistory() {
  const [filterStatus, setFilterStatus] = useState('all');

  const imports = [
    {
      id: 1,
      filename: 'chemical_compatibility_2024.csv',
      source: 'ChemDATA Pro API',
      date: '2024-12-04 10:30 AM',
      records: 523,
      status: 'completed',
      success: 520,
      failed: 3,
    },
    {
      id: 2,
      filename: 'material_database_update.xlsx',
      source: 'Manual Upload',
      date: '2024-12-03 02:15 PM',
      records: 234,
      status: 'completed',
      success: 234,
      failed: 0,
    },
    {
      id: 3,
      filename: 'nist_chemistry_data.json',
      source: 'NIST WebBook',
      date: '2024-12-02 09:45 AM',
      records: 156,
      status: 'failed',
      success: 0,
      failed: 156,
    },
    {
      id: 4,
      filename: 'polymer_compatibility.csv',
      source: 'MatWeb Database',
      date: '2024-12-01 04:20 PM',
      records: 445,
      status: 'completed',
      success: 442,
      failed: 3,
    },
  ];

  const getStatusColor = (status) => {
    switch (status) {
      case 'completed':
        return 'text-green-500 bg-green-500/10';
      case 'failed':
        return 'text-red-500 bg-red-500/10';
      case 'processing':
        return 'text-blue-500 bg-blue-500/10';
      default:
        return 'text-gray-500 bg-gray-500/10';
    }
  };

  const filteredImports =
    filterStatus === 'all'
      ? imports
      : imports?.filter((imp) => imp?.status === filterStatus);

  return (
    <div className="space-y-6">
      {/* Summary Statistics */}
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        <div className="card">
          <div className="flex items-center gap-3">
            <div className="p-2 bg-primary/10 rounded-lg">
              <Icon name="Upload" size={20} className="text-primary" />
            </div>
            <div>
              <div className="text-2xl font-bold text-foreground">42</div>
              <div className="text-sm text-muted-foreground">Total Imports</div>
            </div>
          </div>
        </div>
        <div className="card">
          <div className="flex items-center gap-3">
            <div className="p-2 bg-green-500/10 rounded-lg">
              <Icon name="CheckCircle" size={20} className="text-green-500" />
            </div>
            <div>
              <div className="text-2xl font-bold text-foreground">39</div>
              <div className="text-sm text-muted-foreground">Successful</div>
            </div>
          </div>
        </div>
        <div className="card">
          <div className="flex items-center gap-3">
            <div className="p-2 bg-red-500/10 rounded-lg">
              <Icon name="XCircle" size={20} className="text-red-500" />
            </div>
            <div>
              <div className="text-2xl font-bold text-foreground">3</div>
              <div className="text-sm text-muted-foreground">Failed</div>
            </div>
          </div>
        </div>
        <div className="card">
          <div className="flex items-center gap-3">
            <div className="p-2 bg-blue-500/10 rounded-lg">
              <Icon name="Database" size={20} className="text-blue-500" />
            </div>
            <div>
              <div className="text-2xl font-bold text-foreground">8,234</div>
              <div className="text-sm text-muted-foreground">Total Records</div>
            </div>
          </div>
        </div>
      </div>
      {/* Import History Table */}
      <div className="card">
        <div className="flex items-center justify-between mb-4">
          <div>
            <h3 className="text-lg font-semibold text-foreground">Import History</h3>
            <p className="text-sm text-muted-foreground">View and manage past data imports</p>
          </div>
          <div className="flex gap-2">
            <select
              value={filterStatus}
              onChange={(e) => setFilterStatus(e?.target?.value)}
              className="px-3 py-2 border border-border rounded-lg bg-background text-foreground text-sm"
            >
              <option value="all">All Status</option>
              <option value="completed">Completed</option>
              <option value="failed">Failed</option>
              <option value="processing">Processing</option>
            </select>
            <button className="btn-secondary flex items-center gap-2">
              <Icon name="Download" size={18} />
              Export Log
            </button>
          </div>
        </div>

        <div className="overflow-x-auto">
          <table className="w-full">
            <thead>
              <tr className="border-b border-border">
                <th className="text-left py-3 px-4 font-semibold text-foreground">File</th>
                <th className="text-left py-3 px-4 font-semibold text-foreground">Source</th>
                <th className="text-left py-3 px-4 font-semibold text-foreground">Date</th>
                <th className="text-center py-3 px-4 font-semibold text-foreground">Records</th>
                <th className="text-center py-3 px-4 font-semibold text-foreground">Status</th>
                <th className="text-center py-3 px-4 font-semibold text-foreground">Actions</th>
              </tr>
            </thead>
            <tbody>
              {filteredImports?.map((item) => (
                <tr key={item?.id} className="border-b border-border hover:bg-accent/50 transition-colors">
                  <td className="py-3 px-4">
                    <div className="flex items-center gap-2">
                      <Icon name="File" size={16} className="text-primary" />
                      <span className="font-medium text-foreground">{item?.filename}</span>
                    </div>
                  </td>
                  <td className="py-3 px-4">
                    <span className="text-muted-foreground">{item?.source}</span>
                  </td>
                  <td className="py-3 px-4">
                    <div className="flex items-center gap-1 text-muted-foreground text-sm">
                      <Icon name="Clock" size={14} />
                      {item?.date}
                    </div>
                  </td>
                  <td className="py-3 px-4 text-center">
                    <div className="font-medium text-foreground">{item?.records}</div>
                    <div className="text-xs text-muted-foreground">
                      {item?.success} success, {item?.failed} failed
                    </div>
                  </td>
                  <td className="py-3 px-4 text-center">
                    <span className={`px-2 py-1 rounded text-xs ${getStatusColor(item?.status)}`}>
                      {item?.status}
                    </span>
                  </td>
                  <td className="py-3 px-4">
                    <div className="flex items-center justify-center gap-2">
                      <button className="p-2 hover:bg-accent rounded-lg transition-colors" title="View details">
                        <Icon name="Eye" size={18} className="text-muted-foreground" />
                      </button>
                      <button className="p-2 hover:bg-accent rounded-lg transition-colors" title="Re-import">
                        <Icon name="RefreshCw" size={18} className="text-muted-foreground" />
                      </button>
                      <button className="p-2 hover:bg-accent rounded-lg transition-colors" title="Download">
                        <Icon name="Download" size={18} className="text-muted-foreground" />
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      {/* Recent Errors */}
      <div className="card bg-red-500/5 border border-red-500/20">
        <div className="flex items-center gap-3 mb-4">
          <Icon name="AlertCircle" size={20} className="text-red-500" />
          <div>
            <h3 className="font-semibold text-foreground">Recent Import Errors</h3>
            <p className="text-sm text-muted-foreground">Issues that need attention</p>
          </div>
        </div>
        <div className="space-y-2">
          <div className="p-3 bg-background rounded-lg">
            <div className="flex items-start justify-between">
              <div>
                <div className="font-medium text-foreground text-sm mb-1">
                  Invalid CAS number format
                </div>
                <div className="text-xs text-muted-foreground">
                  File: nist_chemistry_data.json • 156 records affected
                </div>
              </div>
              <button className="text-sm text-primary hover:underline">Fix</button>
            </div>
          </div>
          <div className="p-3 bg-background rounded-lg">
            <div className="flex items-start justify-between">
              <div>
                <div className="font-medium text-foreground text-sm mb-1">
                  Duplicate entries detected
                </div>
                <div className="text-xs text-muted-foreground">
                  File: chemical_compatibility_2024.csv • 3 records affected
                </div>
              </div>
              <button className="text-sm text-primary hover:underline">Review</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}